(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("LogTypeDialogController", LogTypeDialogController);

    LogTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "LogType",
        "User",
        "LogTypeSearch",
        "AllCustomLogTypeAttribute",
    ];

    
    function LogTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        LogType,
        User,
        LogTypeSearch,
        AllCustomLogTypeAttribute
    ) {
        var vm = this;
        //logtype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.logType = entity;
        vm.logTypeImageName = logTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customLogTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function logTypeImageName(image) {
            vm.logType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomLogTypeAttribute.getAll(function (response) {
                vm.customLogTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customLogTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.logType.logTypeAttribute != null &&
            vm.logType.logTypeAttribute.length != 0
        ) {
            vm.items = vm.logType.logTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.logCategory == null) {
                value.logCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.logType.id !== null) {
                vm.logType.logTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.logType.logTypeAttribute.push({
                        logCategory: vm.items[i].logCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        logTypeAttribOrder: vm.items[i].logTypeAttribOrder
                    });
                }
                LogType.update(vm.logType, onSaveSuccess, onSaveError);
            } else {
                vm.logType.logTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.logType.logTypeAttribute.push({
                        logCategory: vm.items[i].logCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        logTypeAttribOrder: vm.items[i].logTypeAttribOrder
                    });
                }
                LogType.save(vm.logType, onSaveSuccess, onSaveError);
            }
        }

        $("#logTypeImage").change(function () {
            var filesSelected = document.getElementById("logTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.logType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:logTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("log-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();
